// extracted by mini-css-extract-plugin
export var filterIncDec = "_9p-0";
export var leftBorder = "_9p-1";
export var rightBorder = "_9p-2";
export var stringInput = "_9p-3";